var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconContainerTabbed = function SvgMiconContainerTabbed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 3a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1H16V4a1 1 0 0 0-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 4h12a1 1 0 0 1 1 1v5"
  })));
};
export default SvgMiconContainerTabbed;